// extracted by mini-css-extract-plugin
export var activeFilterButton = "_j9-c";
export var backButton = "_j9-4";
export var backIcon = "_j9-5";
export var chevronShortcut = "_j9-6";
export var container = "_j9-1";
export var editor = "_j9-8";
export var editorWrapper = "_j9-7";
export var prefix = "_j9-2";
export var searchIcon = "_j9-3";
export var suffix = "_j9-9";
export var suffixContent = "_j9-a";
export var suffixText = "_j9-b";
export var wrapper = "_j9-0";